    CF.ready(function() {
        var validation = {
          comparator: function isValid(fieldValue) {
            // if fieldValue is valid:
            if(fieldValue.$D != $('.cf-select-wrap:nth-child(3) select').val() || fieldValue.$M + 1 != $('.cf-select-wrap:nth-child(2) select').val()){
                return false;
            } else {
                return true;
            }
          },
      
          // Display this error message if the comparator does not return true
          errorMessage: 'Field value is not valid',
      
          // If your comparator is asynchronous (if it returns a Promise,) set this to true. 
          // Otherwise, you don't need it. More on this below!
          async: false,
        };
      
        var $form = document.querySelector('form[data-cf-form]');
      
        // Add this validation to all fields with a data column key of "first_name"
        $form.cfForm.addValidator(validation, 'birthday');
      });